import { Bundle, indexBundles } from "@greeter/core";
import { CartItemBundle } from "./CartMachine";

export function summarizeBundleCartItem(
  cartItem: CartItemBundle,
  bundle: Bundle
) {
  const s: Array<string> = [];
  const indexedBundle = indexBundles([bundle]);
  for (const [bundleLineId, picks] of cartItem.picks.entries()) {
    const line = indexedBundle.lines.get(bundleLineId);
    if (!line) continue;
    s.push(`${line?.name}:\n`);

    for (const [bundleLineVariantId, variant] of picks.entries()) {
      let quantity = 0;
      for (const v of variant.values()) {
        quantity += v.type === "normal" ? v.quantity ?? 0 : 0;
      }
      if (quantity <= 0) continue;

      const _variant = indexedBundle.variants.get(bundleLineVariantId);
      s.push(`${quantity} x ${_variant?.name}\n`);
    }
  }
  return s.join("");
}
